import { IHeader } from '@/bundles/BaseTable/interfaces';
import { OpexDisplayEnum } from '@/bundles/Members/enums';
import { getOpexDisplayLabel } from '@/bundles/Members/helpers';
import i18n from '@/bundles/Localization';
import { LocalizationEnum } from '@/bundles/Localization/enum/LocalizationEnum';

export const CUSTOM_SORT = 'custom_sort';

export const availabilitiesAdminHeadersData: IHeader[] = [
  { text: 'Photo', sortable: false },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Property Name', value: 'name', class: '', sortable: true, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Address', value: 'address', class: '', sortable: true, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Address 2', value: 'address2', class: '', sortable: true, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'City', value: 'address.city', class: '', sortable: true, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'State', value: 'address.state', class: '', sortable: true, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Zip Code', value: 'address.zip', class: '', sortable: true, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Building Class', value: 'property.building.class', class: '', sortable: true, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Construction Status', value: 'property.construction_status', class: '', sortable: true, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Property Type', value: 'propertyType', class: '', sortable: true, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Primary Use', value: 'primary_use', class: '', sortable: true, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Secondary Use', value: 'secondary_use', class: '', sortable: true, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Use Types', value: 'use_types', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Center Type', value: 'property.center_type', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Tenant Type', value: 'p.building.tenant_type', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Unit Mix', value: 'p.building.unit_mix', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Style', value: 'p.building.style', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: '# of Units / Keys', value: 'p.building.units', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Transaction Type', value: 'transaction_type', class: '', sortable: false, icon: 'string' }, ],
  },

  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Available Space', value: 'available_space', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Divisible Space', value: 'divisible_space', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Building Size', value: 'building_size', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Rentable Bldg Size', value: 'rentable_building_size', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Floor', value: 'floor', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: '# of Floors', value: 'number_of_floors', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Net Dev. Land', value: 'net_dev_land', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Year Built', value: 'year_built', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Year Renovated', value: 'year_renovated', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Zoning', value: 'zoning', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'APN Number', value: 'apn_number', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Latitude', value: 'latitude', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Longitude', value: 'longitude', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Parking Spaces (Building)', value: 'parking_spaces_building', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Parking Ratio (Building)', value: 'parking_ratio_building', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Parking Spaces (Space)', value: 'parking_spaces_space', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Parking Ratio (Space)', value: 'parking_ratio_space', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Office Space', value: 'office_space', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Clear Height', value: 'ceiling_height', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: '# Dock Doors', value: 'truck_level_doors', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: '# Drive In Doors', value: 'ground_level_doors', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Date Available', value: 'date_available', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Date On Market', value: 'date_on_market', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Months On Market', value: 'months_on_market', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Created By', value: 'created_by', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Revised By', value: 'revised_by', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Revised Date', value: 'revised_date', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Sprinklers', value: 'sprinklers', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Asking Sale Price', value: 'asking_sale_price', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Asking Sale Price PSF', value: 'asking_sale_price_sf', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Asking Sale Price Per Unit/Key', value: 'asking_sale_price_unit', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Cap Rate', value: 'cap_rate', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: '% Leased', value: 'percent_leased', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'NOI', value: 'noi', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Lease Rate', value: 'lease_rate', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Lease Type', value: 'lease_type', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'NNN / TMI', value: 'tmi', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Investment', value: 'investment', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Amps', value: 'amps', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'Volts', value: 'volts', class: '', sortable: false, icon: 'string' }, ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [ { text: 'True Owner', value: 'true_owner', class: '', sortable: false, icon: 'string' }, ],
  },
];

export const getAvailabilitiesCardHeadersData = (sourceType: string, opexDisplay: OpexDisplayEnum): IHeader[] => [
  { text: '#', value: 'number', sortable: false },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Property Name',
        value: 'name',
        class: '',
        sortable: sourceType !== 'property',
        icon: 'string'
      },
      {
        text: 'more address',
        value: 'citystatezip',
        sortable: false,
        class: '',
        icon: 'string',
        multi: [
          {
            text: 'Address',
            value: 'address',
            class: '',
            sortable: sourceType !== 'property',
            icon: 'string',
          },
          {
            text: 'Address 2',
            value: 'address2',
            class: '',
            sortable: true,
            icon: 'string',
          },
        ]
      },
      {
        text: 'Property Type',
        value: 'propertyType',
        class: '',
        sortable: sourceType !== 'property',
        icon: 'string'
      }
    ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Available Space',
        value: 'available_space',
        class: '',
        sortable: true,
        icon: 'number',
      },
      {
        text: 'Divisible Space',
        value: 'divisible_space',
        class: '',
        sortable: true,
        icon: 'number',
      }
    ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Building Size',
        value: 'building_size',
        class: '',
        sortable: true,
        icon: 'number',
      },
      {
        text: 'Construction Status',
        value: 'property.construction_status',
        class: '',
        sortable: sourceType !== 'property',
        icon: 'string',
      },
      {
        text: 'Vacancy Status',
        value: 'property.vacancy_status',
        class: '',
        sortable: true,
        icon: 'string',
      },
    ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Land Size',
        value: 'land_size',
        class: '',
        sortable: true,
        icon: 'number',
      },
      {
        text: 'Divisible Land Size',
        value: 'divisible_land_size',
        class: '',
        sortable: true,
        icon: 'number',
      }
    ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Office Space',
        value: 'office_space',
        class: '',
        sortable: true,
        icon: 'number',
      },
    ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Clear Height',
        value: 'min_clear_height',
        sortable: true,
        icon: 'string',
      },
      {
        text: 'Dock Doors',
        value: 'dock_doors',
        sortable: true,
        icon: 'string',
      },
      {
        text: '# Drive-In Doors',
        value: 'ramp_grade',
        class: '',
        sortable: true,
        icon: 'string',
      },
    ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Sprinklers',
        value: 'sprinklers',
        class: '',
        sortable: true,
        icon: 'string',
      },
    ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Price',
        value: 'sale_price',
        class: '',
        sortable: true,
        icon: 'number',
      },
      {
        text: 'Per SF',
        value: 'sale_price_sf',
        class: '',
        sortable: true,
        icon: 'number',
      },
      {
        text: 'Cap Rate',
        value: 'cap_rate',
        class: '',
        sortable: true,
        icon: 'number',
      }
    ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Lease Rate',
        value: 'lease_rate',
        class: '',
        sortable: true,
        icon: 'number',
      },
      {
        text: 'Type',
        value: 'lease_type',
        class: '',
        sortable: false,
        icon: 'string',
      },
    ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: getOpexDisplayLabel(opexDisplay),
        value: 'operation_expenses',
        class: '',
        sortable: true,
        icon: 'number',
      },
      {
        text: 'TI Allowance',
        value: 'ti_allowance',
        class: '',
        sortable: true,
        icon: 'number',
      },
    ],
  },
  {
    text: 'Available',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Available',
        value: 'available_date',
        class: '',
        sortable: true,
        icon: 'date',
      },
      {
        text: 'On Market (months)',
        value: 'date_on_market',
        class: '',
        sortable: true,
        icon: 'date',
      },
    ],
  },
  { text: 'True Owner', value: 'true_owner', class: '', sortable: false },
  { text: `${i18n.tc(LocalizationEnum.broker, 2)}`, value: 'broker', class: '', sortable: false },
  {
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Updated',
        value: 'updated.date',
        sortable: true,
        icon: 'date',
      },
      {
        text: 'Created',
        value: 'created.date',
        sortable: true,
        icon: 'date',
      },
      {
        text: 'Status',
        value: 'status',
        class: '',
        sortable: true,
        icon: 'string',
      },
      {
        text: 'Validation',
        value: 'verification',
        class: '',
        sortable: false,
        icon: 'string',
      },
    ],
  },
];

// withCustomField: only the Availabilities list's client view offers the custom field; the merge table
// and dashboard card reuse these headers without it.
export const getAvailabilityClientHeadersData = (opexDisplay: OpexDisplayEnum, { isStaticSetSelected, isCustomSortApplied, withCustomField }: {
  isStaticSetSelected?: boolean;
  isCustomSortApplied?: boolean;
  withCustomField?: boolean;
} = {
  isStaticSetSelected: false,
  isCustomSortApplied: false,
  withCustomField: false,
}): IHeader[] => {
  const customSortHeader = {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Custom Sort',
        value: CUSTOM_SORT,
        class: '',
        sortable: true,
      },
    ],
  };

  const isReplaceImageHeader = isStaticSetSelected && !isCustomSortApplied;

  const headers = [
    isReplaceImageHeader ? customSortHeader : { text: '', value: 'image', sortable: false },
    {
      text: 'Multi',
      value: 'multi',
      sortable: false,
      multi: [
        {
          text: 'Property Name',
          value: 'name',
          class: '',
          sortable: true,
          icon: 'string'
        },
        {
          text: 'Address',
          value: 'address, street_name',
          sortable: false,
          icon: 'string',
          multi: [
            {
              text: 'Address',
              value: 'address',
              sortable: true,
              class: '',
              icon: 'string',
            },
            {
              text: 'Street Name',
              value: 'street_name',
              sortable: true,
              class: '',
              icon: 'string'
            },
          ]
        },
        {
          text: 'Property Type',
          value: 'propertyType',
          class: '',
          sortable: true,
          icon: 'string'
        }
      ],
    },
    {
      text: 'Multi',
      value: 'multi',
      sortable: false,
      multi: [
        {
          text: 'Available Space',
          value: 'available_space',
          class: '',
          sortable: true,
          icon: 'number',
        },
        {
          text: 'Divisible Space',
          value: 'divisible_space',
          class: '',
          sortable: true,
          icon: 'number',
        }
      ],
    },
    {
      text: 'Multi',
      value: 'multi',
      sortable: false,
      multi: [
        {
          text: 'Building Size',
          value: 'building_size',
          class: '',
          sortable: true,
          icon: 'number',
        },
        {
          text: 'Multi',
          value: 'Multi',
          multi: [
            {
              text: 'Construction Status,',
              value: 'property.construction_status',
              class: '',
              sortable: true,
              icon: 'string',
            },
            {
              text: 'Yr Built',
              value: 'year_built',
              class: '',
              sortable: true,
              icon: 'number',
            },
          ]
        },
        {
          text: 'Vacancy Status',
          value: 'property.vacancy_status',
          class: '',
          sortable: true,
          icon: 'string',
        },
      ],
    },
    {
      text: 'Multi',
      value: 'multi',
      sortable: false,
      multi: [
        {
          text: 'Land Size',
          value: 'land_size',
          class: '',
          sortable: true,
          icon: 'number',
        },
        {
          text: 'Divisible Land Size',
          value: 'divisible_land_size',
          class: '',
          sortable: true,
          icon: 'number',
        }
      ],
    },
    {
      text: 'Multi',
      value: 'multi',
      sortable: false,
      multi: [
        {
          text: 'Office Space',
          value: 'office_space',
          class: '',
          sortable: true,
          icon: 'number',
        },
      ],
    },
    {
      text: 'Multi',
      value: 'multi',
      sortable: false,
      multi: [
        {
          text: 'Clear Height',
          value: 'min_clear_height',
          sortable: true,
          icon: 'string',
        },
        {
          text: 'Dock Doors',
          value: 'dock_doors',
          sortable: true,
          icon: 'string',
        },
        {
          text: '# Drive-In Doors',
          value: 'ramp_grade',
          class: '',
          sortable: true,
          icon: 'string',
        },
      ],
    },
    {
      text: 'Multi',
      value: 'multi',
      sortable: false,
      multi: [
        {
          text: 'Sprinklers',
          value: 'sprinklers',
          class: '',
          sortable: true,
          icon: 'string',
        },
      ],
    },
    {
      text: 'Multi',
      value: 'multi',
      sortable: false,
      multi: [
        { text: 'Price', value: 'sale_price', class: '', sortable: true, icon: 'number' },
        { text: 'Per SF', value: 'sale_price_sf', class: '', sortable: true, icon: 'number' },
        { text: 'Cap Rate', value: 'cap_rate', class: '', sortable: true, icon: 'number' },
      ],
    },
    {
      text: 'Multi',
      value: 'multi',
      sortable: false,
      multi: [
        {
          text: 'Lease Rate',
          value: 'lease_rate',
          class: '',
          sortable: true,
          icon: 'number',
        },
        {
          text: 'Type',
          value: 'lease_type',
          class: '',
          sortable: false,
          icon: 'string',
        },
      ],
    },
    {
      text: 'Multi',
      value: 'multi',
      sortable: false,
      multi: [
        {
          text: getOpexDisplayLabel(opexDisplay),
          value: 'operation_expenses',
          class: '',
          sortable: true,
          icon: 'number',
        },
        {
          text: 'TI Allowance',
          value: 'ti_allowance',
          class: '',
          sortable: true,
          icon: 'number',
        },
      ],
    },
    {
      text: 'Available',
      value: 'multi',
      sortable: false,
      multi: [
        {
          text: 'Available',
          value: 'available_date',
          class: '',
          sortable: true,
          icon: 'date',
        },
        {
          text: 'On Market (months)',
          value: 'date_on_market',
          class: '',
          sortable: true,
          icon: 'date',
        },
      ],
    },
    { text: 'True Owner', value: 'true_owner', class: '', sortable: false },
    {
      value: 'multi',
      sortable: false,
      multi: [
        { text: 'Listing Company', value: 'availability_company', class: '', sortable: true, icon: 'string' },
        { text: `Listing ${i18n.tc(LocalizationEnum.broker, 2)}`, value: 'broker', class: '', sortable: false }
      ]
    },

    {
      value: 'multi',
      sortable: false,
      multi: [
        {
          text: 'Updated',
          value: 'updated.date',
          sortable: true,
          icon: 'date',
        },
        {
          text: 'Created',
          value: 'created.date',
          sortable: true,
          icon: 'date',
        },
        {
          text: 'Status',
          value: 'status',
          class: '',
          sortable: true,
          icon: 'string',
        },
        {
          text: 'Validation',
          value: 'verification',
          class: '',
          sortable: false,
          icon: 'string',
        },
        ...(withCustomField ? [{ text: '', value: 'custom_field', sortable: false, icon: 'string' }] : []),
      ],
    },
  ];

  return isStaticSetSelected && isCustomSortApplied ? [customSortHeader, ...headers] : headers;
};

export const availabilityWorkflowHeadersData: IHeader[] = [
  { text: '', value: 'image', sortable: false },
  {
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Property Name',
        value: 'name',
        class: '',
        sortable: true,
        icon: 'string',
      },
      {
        text: 'Address',
        value: 'address, street_name',
        sortable: false,
        icon: 'string',
        multi: [
          {
            text: 'Address',
            value: 'address',
            sortable: true,
            class: '',
            icon: 'string',
          },
          {
            text: 'Street Name',
            value: 'street_name',
            sortable: true,
            class: '',
            icon: 'string'
          },
        ]
      },
      {
        text: 'Property Type',
        value: 'propertyType',
        class: '',
        sortable: true,
        icon: 'string'
      }
    ],
  },
  {
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Available Space',
        value: 'available_space',
        class: '',
        sortable: true,
        icon: 'number',
      },
      {
        text: 'Divisible Space',
        value: 'divisible_space',
        class: '',
        sortable: true,
        icon: 'number',
      },
    ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Building Size',
        value: 'building_size',
        class: '',
        sortable: true,
        icon: 'number',
      },
      {
        text: 'Year Built',
        value: 'year_built',
        class: '',
        sortable: true,
        icon: 'number',
      },
      {
        text: 'Construction Status',
        value: 'property.construction_status',
        class: '',
        sortable: true,
        icon: 'string',
      },
    ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Web Content Indicator',
        value: 'web_content_indicator',
        sortable: true,
        icon: 'number',
      },
    ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Marketing Push',
        value: 'marketing_push',
        class: 'text-center',
        sortable: true,
        icon: 'number',
      },
    ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Published to Web',
        value: 'website_push',
        class: 'text-center',
        sortable: true,
        icon: 'number',
      },
    ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Listing Agreement',
        value: 'listing_agreement',
        class: 'text-center',
        sortable: true,
        icon: 'string',
      },
      {
        text: 'Expiration Date',
        value: 'listing_agreement.expiration_date',
        class: 'text-center',
        sortable: true,
        icon: 'date',
      },
    ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Active\n In House Exclusive',
        class: 'text-center white-space--pre-line',
        sortable: true,
        icon: 'string',
        value: 'active_inhouse_exclusive'
      },
    ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Property Sign',
        value: 'sign',
        class: 'text-center',
        sortable: true,
        center: true,
        icon: 'string',
      },
      {
        text: 'Install Date',
        value: 'sign.install_date',
        class: 'last-date-label text-center',
        sortable: true,
        icon: 'date',
      },
    ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Flyer (90 days)',
        value: 'property_flyer',
        class: 'text-center',
        sortable: true,
        icon: 'string',
      },
      {
        text: 'Last Updated',
        value: 'property_flyer.date',
        class: 'last-date-label text-center',
        sortable: true,
        icon: 'date',
      },
    ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Eblast (5 weeks)',
        value: 'has_eblast',
        class: 'text-center',
        sortable: true,
        icon: 'string',
      },
      {
        text: 'Last Sent',
        value: 'eblast',
        class: 'last-date-label text-center',
        sortable: true,
        icon: 'date',
      },
    ],
  },
  {
    text: 'Multi',
    value: 'multi',
    sortable: false,
    multi: [
      {
        text: 'Syndication (30 days)',
        value: 'has_syndication',
        class: 'text-center',
        sortable: true,
        icon: 'string',
      },
      {
        text: 'Last Update',
        value: 'eblast_last_sent',
        class: 'last-date text-center',
        sortable: true,
        icon: 'date',
      },
    ],
  },
];
